module.exports = __webpack_public_path__ + "img/stripe-system.87898fc8.svg";